module.exports = __webpack_public_path__ + "static/media/modal.77dc9d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/modal.png
// module id = 182
// module chunks = 0